export const CourseData = [
    {
        name: "Complete SDE Bootcamp",
        price: "   ₹ 2000",
        mrp: "   ₹ 5000"
    },
    {
        name: "Aptitude Series - Self Pace",
        price: "₹ 1000",
        mrp: "   ₹ 5000"
    },
    {
        name: "Core Subjects - Crash Course",
        price: "₹ 2200",
        mrp: "   ₹ 5000"
    }
]